import React, { useMemo } from 'react'
import Rapid7InsightVMMappingForm from './Rapid7InsightVMMappingForm';
import Rapid7InsightVMCredentialsForm from './Rapid7InsightVMCredentialsForm';
import GenericPullConfigListing from '../GenericPullConfigListing';
import { isEmpty } from 'lodash';
import { CellRenderers } from 'utils/tableUtils';
import ContentOverlay from 'components/ContentOverlay';

export default function Rapid7InsightVMConfigListing(props) {

    const columns = useMemo(
        () => [
          {
            title: "Tag Names",
            dataIndex: "tagNames",
            width: 130,
            render: (tagName) =>
              isEmpty(tagName) ? "All" : <ContentOverlay content={CellRenderers.VALUE_OR_NA(tagName)} minHeight={40}/>
          },
        ],
        [],
    );
    
    return (
        <GenericPullConfigListing
            {...props}
            toolName={props.name}
            MappingForm={Rapid7InsightVMMappingForm}
            CredentialsForm={Rapid7InsightVMCredentialsForm}
            extraColumns={columns}
        />
    )
}